import { SET_EXPIRATION_TOKEN, SET_REFERRAL_course_slug, SET_REFERRAL_ID, SET_TOKEN } from "../actions/types";
import { PURGE } from 'redux-persist'

export default function (state = null, action) {
    switch (action.type) {
        case PURGE:
            return null;
        case SET_TOKEN:
            return {
                ...state,
                user_token: action.payload
            }
        case SET_EXPIRATION_TOKEN:
            return {
                ...state, set_expiration_token: action?.payload
            }
        default:
            return state;
    }
}